import { useSupportProfile } from "@/tanstack-hooks";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { useState } from "react";
import { CONTACT } from "@/constants";
import { useTranslation } from "@/hooks/useTranslation";
import { MessageCircleIcon } from "lucide-react";
import NewMessageDrawerDialog from "../messages/NewMessageDrawerDialog";
import DeleteAccountButton from "./DeleteAccountButton";

export default function ContactSupportCard() {
  const [messageDrawerOpen, setMessageDrawerOpen] = useState(false);
  const supportProfileQuery = useSupportProfile();
  const t = useTranslation();

  const supportProfile = supportProfileQuery.data;

  return (
    <>
      <Card className="dark w-full max-w-lg">
        <CardHeader className="pb-2">
          <CardTitle className="text-md">
            {t.SETTINGS_FEEDBACK_CARD.LABELS.TITLE}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-start gap-y-4">
            {supportProfile && (
              <Button onClick={() => setMessageDrawerOpen(true)}>
                <MessageCircleIcon className="mr-2 fill-black" />
                {t.SETTINGS_FEEDBACK_CARD.LABELS.MESSAGE_FOUNDERS_BUTTON}
              </Button>
            )}
            <span className="text-sm text-gray-400 mr-2">
              {t.SETTINGS_FEEDBACK_CARD.LABELS.EMAIL_US}{" "}
              <a
                href={`mailto:${CONTACT.SUPPORT_EMAIL}`}
                className="underline font-semibold"
              >
                {CONTACT.SUPPORT_EMAIL}
              </a>
              .
            </span>
          </div>
          <div className="h-px bg-zinc-800 my-4" />
          <DeleteAccountButton />
        </CardContent>
      </Card>

      {supportProfile && (
        <NewMessageDrawerDialog
          open={messageDrawerOpen}
          profile={{
            profile_id: supportProfile.user_id,
            display_name: supportProfile.name,
            photo_url: supportProfile.photo_url,
            age: supportProfile.age,
            city_name: supportProfile.city_name,
            country_alpha_2: supportProfile.country_alpha_2,
            languages: supportProfile.languages,
          }}
          onClose={() => setMessageDrawerOpen(false)}
          isSupport={true}
        />
      )}
    </>
  );
}
